<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ formTitle }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="formData.description_method_discount"
              label="Descripción del descuento"
              :rules="[v => !!v || 'El nombre es requerido']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-select
              v-model="formData.method_discount"
              :items="methodOptions"
              item-text="label"
              item-value="value"
              label="Tipo de descuento"
              :rules="[v => !!v || 'El método de pago es requerido']"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model.number="formData.discount"
              :label="
                `Descuento (${
                  formData.method_discount === 'fixed' ? '$' : '%'
                })`
              "
              type="number"
              :rules="[
                v => (v !== null && v !== '') || 'El descuento es requerido'
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-select
              v-model="formData.condition"
              :items="conditionOptions"
              item-text="label"
              item-value="value"
              label="Condición para las unidades"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model.number="formData.properties_apply_discount"
              label="Numero Unidades"
              type="number"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-select
              :items="propertyCodeOptions"
              v-model="formData.propertys_code"
              clearable
              chips
              color="#042956"
              prepend-icon="mdi-city"
              item-text="name"
              label="Propiedades (Por default: todas)"
              multiple
              deletable-chips
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption"
                  >(+{{ formData.propertys_code.length - 1 }} otros)</span
                >
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-select
              v-model="formData.allowed_entities"
              :items="roleOptions"
              item-text="description"
              item-value="value"
              label="Visible por"
              multiple
              chips
              required
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.description }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text text-caption">
                  (+{{ formData.roles.length - 2 }} más)
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="handleCancel">
        Cancelar
      </v-btn>
      <v-btn color="blue darken-1" text @click="handleSubmit">
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DiscountForm",
  props: {
    value: {
      type: Object,
      default: () => ({
        method_discount: "",
        discount: "",
        months_discount: "",
        description_method_discount: "",
        properties_apply_discount: "",
        condition: "",
        propertys_code: [],
        allowed_entities: ["role:admin"]
      })
    },
    propertyCodeOptions: {
      type: Array,
      default: () => []
    },
    roleOptions: {
      type: Array,
      default: () => []
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.value },
      conditionOptions: [
        {
          label: "Igual",
          value: "equals"
        },
        {
          label: "Mayor",
          value: "greater"
        },
        {
          label: "Menor",
          value: "less"
        }
      ],
      methodOptions: [
        {
          label: "Porcentaje",
          value: "percentage"
        },
        {
          label: "Fijo",
          value: "fixed"
        }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.isEditing ? "Editar Descuento" : "Nuevo Descuento";
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.formData = { ...newVal };
      },
      deep: true
    }
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", this.formData);
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>
